import { render, staticRenderFns } from "./CU-Login.vue?vue&type=template&id=b32af238&scoped=true"
import script from "./CU-Login.vue?vue&type=script&lang=js"
export * from "./CU-Login.vue?vue&type=script&lang=js"
import style0 from "./CU-Login.vue?vue&type=style&index=0&id=b32af238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32af238",
  null
  
)

export default component.exports